// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popupContainer_ABotK {
	position: relative;
	width: 350px;
	border-radius: 8px;
	padding: 8px;
	display: flex;
	flex-direction: column;
	z-index: 900000;
	gap: 7px;
}
.popupTitle_hva9Z {
	font-size: 20px;
	color: var(--_3c3a3a-color);
	font-weight: 600;
}


.inputContainer_Cb8B9 {
	display: flex;
	flex-direction: column;
}

.inputField_tdquz,
.textArea_f23Aq{
	width: 100%;
	padding: 10px;
	border-radius: 4px;
	font-size: 14px;
	background-color: var(--f5-background);
	outline: none;
	margin-top: 5px;
}

.textArea_f23Aq {
	height: 80px;
	resize: none;
	background: var(--f5-background);
	border: none !important;
}

.ownerInfo_qTftt {
	display: flex;
	flex-direction: column;
}

.ownerName_pNQMe {
	margin-top: 5px;
	font-size: 14px;
}

.createButton_h24Mr {
	background-color: var(--_16c098-color);
	color: var(--white-color);
	border: none;
	padding: 10px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 15px;
	font-weight: 600;
	margin-top: 10px;
	transition: background-color 0.3s ease;
}

.createButton_h24Mr:hover {
	background-color: var(--_16c09821-background);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/CreateCalendarPopUp.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,eAAe;CACf,QAAQ;AACT;AACA;CACC,eAAe;CACf,2BAA2B;CAC3B,gBAAgB;AACjB;;;AAGA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;;CAEC,WAAW;CACX,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,sCAAsC;CACtC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,gCAAgC;CAChC,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,sCAAsC;CACtC,yBAAyB;CACzB,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,sCAAsC;AACvC;;AAEA;CACC,6CAA6C;AAC9C","sourcesContent":[".popupContainer {\n\tposition: relative;\n\twidth: 350px;\n\tborder-radius: 8px;\n\tpadding: 8px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tz-index: 900000;\n\tgap: 7px;\n}\n.popupTitle {\n\tfont-size: 20px;\n\tcolor: var(--_3c3a3a-color);\n\tfont-weight: 600;\n}\n\n\n.inputContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.inputField,\n.textArea{\n\twidth: 100%;\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tfont-size: 14px;\n\tbackground-color: var(--f5-background);\n\toutline: none;\n\tmargin-top: 5px;\n}\n\n.textArea {\n\theight: 80px;\n\tresize: none;\n\tbackground: var(--f5-background);\n\tborder: none !important;\n}\n\n.ownerInfo {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.ownerName {\n\tmargin-top: 5px;\n\tfont-size: 14px;\n}\n\n.createButton {\n\tbackground-color: var(--_16c098-color);\n\tcolor: var(--white-color);\n\tborder: none;\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\tfont-size: 15px;\n\tfont-weight: 600;\n\tmargin-top: 10px;\n\ttransition: background-color 0.3s ease;\n}\n\n.createButton:hover {\n\tbackground-color: var(--_16c09821-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popupContainer": `popupContainer_ABotK`,
	"popupTitle": `popupTitle_hva9Z`,
	"inputContainer": `inputContainer_Cb8B9`,
	"inputField": `inputField_tdquz`,
	"textArea": `textArea_f23Aq`,
	"ownerInfo": `ownerInfo_qTftt`,
	"ownerName": `ownerName_pNQMe`,
	"createButton": `createButton_h24Mr`
};
export default ___CSS_LOADER_EXPORT___;
